import { steps } from "@/mocks/home";

export default function Onboarding() {
  return (
    <section className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-xs uppercase tracking-widest text-accent-700 font-semibold">Onboarding</span>
          <h2 className="mt-3 text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
            Live voice traffic in four steps.
          </h2>
          <p className="mt-4 text-foreground-700 leading-relaxed">
            No 90-day integrations, no month-long paperwork. Most operators send their first billable minute within a week.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-px bg-gradient-to-r from-primary-300 via-accent-300 to-primary-300" />
          {steps.map((s, i) => (
            <div key={s.n} className="relative flex flex-col items-center text-center">
              <div className="relative z-10 w-16 h-16 rounded-full bg-background-50 border-2 border-primary-500 text-primary-600 flex items-center justify-center font-heading font-semibold text-lg">
                {s.n}
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-950 font-heading">{s.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed max-w-[220px]">{s.desc}</p>
              {i < steps.length - 1 && (
                <i className="ri-arrow-right-line hidden md:flex md:absolute md:top-6 md:-right-3 text-primary-500 w-6 h-6 items-center justify-center" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}